import React, { PureComponent } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHEContainer } from 'data/components';
import { Toastr } from 'data/common';
import { getNotificationDetails, getDefaultNotificationsButtons, updateNotificationDetails } from '../../data/Notifications/actions';
import FormNotification from './Form/FormNotification';

class NotificationDetails extends PureComponent {
    static propTypes = {
        getNotificationDetails: PropTypes.func.isRequired,
        defaultButtons: PropTypes.object.isRequired,
        updateNotificationDetails: PropTypes.func.isRequired,
        getDefaultNotificationsButtons: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getAllData();
    }

    getAllData = () => {
        const { defaultButtons } = this.props;
        this.setState({ loading: true, error: null });
        const promises = [this.getNotificationDetails()];
        if (defaultButtons.size === 0) promises.push(this.getDefaultNotificationsButtons());
        Promise.all(promises)
            .then(() => this.setState({ loading: false, error: null }))
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                this.setState({ loading: false, error: message });
            });
    };

    getNotificationDetails = () => {
        const { getNotificationDetails, match } = this.props;
        return getNotificationDetails(match.params.notificationId).catch(err => {
            Toastr.error(Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default'));
            throw err;
        });
    };

    getDefaultNotificationsButtons = () => {
        const { getDefaultNotificationsButtons } = this.props;
        return getDefaultNotificationsButtons().catch(err => {
            Toastr.error(Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default'));
            throw err;
        });
    };

    renderChildren = () => {
        const { updateNotificationDetails } = this.props;
        return <FormNotification type="update" sendDataFunc={updateNotificationDetails} />;
    };

    render() {
        const { loading, error } = this.state;
        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getAllData} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state) {
    return {
        defaultButtons: state.environments.fhe.data.Notifications.getIn(['defaultButtons'], new Map()),
        profile: state.data.user,
        initialized: state.environments.fhe.data.Notifications.get('initialized')
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ updateNotificationDetails, getNotificationDetails, getDefaultNotificationsButtons }, dispatch)
    )(NotificationDetails)
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/details.js